export default "__VITE_ASSET__BMiaBef3__"